'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScheduledMealSearch(startTime, endTime, mealType, headerOnly, includeDeleted, pageIndex, pageSize, sort) {
  this.D9 = null;
  this.D3 = null;
  this.D6 = null;
  this.D4 = false;
  this.D5 = false;
  this.D7 = 0;
  this.D8 = 0;
  this.LC = null;
  this.D9 = startTime;
  this.D3 = endTime;
  this.D6 = mealType;
  this.D4 = headerOnly;
  this.D5 = includeDeleted;
  this.D7 = pageIndex;
  this.D8 = pageSize;
  this.LC = sort;
}
export { $c_Lmealorama_ScheduledMealSearch as $c_Lmealorama_ScheduledMealSearch };
$p = $c_Lmealorama_ScheduledMealSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScheduledMealSearch;
/** @constructor */
function $h_Lmealorama_ScheduledMealSearch() {
}
export { $h_Lmealorama_ScheduledMealSearch as $h_Lmealorama_ScheduledMealSearch };
$h_Lmealorama_ScheduledMealSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-706381896));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.D9));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.D3));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.D6));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.D4 ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.D5 ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.D7);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.D8);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.LC));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 8);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_ScheduledMealSearch)) {
    if (((((this.D4 === x$0.D4) && (this.D5 === x$0.D5)) && (this.D7 === x$0.D7)) && (this.D8 === x$0.D8))) {
      var x = this.D9;
      var x$2 = x$0.D9;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.D3;
      var x$4 = x$0.D3;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.D6;
      var x$6 = x$0.D6;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.LC;
      var x$8 = x$0.LC;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 8;
});
$p.r = (function() {
  return "ScheduledMealSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.D9;
      break;
    }
    case 1: {
      return this.D3;
      break;
    }
    case 2: {
      return this.D6;
      break;
    }
    case 3: {
      return this.D4;
      break;
    }
    case 4: {
      return this.D5;
      break;
    }
    case 5: {
      return this.D7;
      break;
    }
    case 6: {
      return this.D8;
      break;
    }
    case 7: {
      return this.LC;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_ScheduledMealSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jU)));
}
export { $isArrayOf_Lmealorama_ScheduledMealSearch as $isArrayOf_Lmealorama_ScheduledMealSearch };
var $d_Lmealorama_ScheduledMealSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScheduledMealSearch, "mealorama.ScheduledMealSearch", ({
  jU: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_ScheduledMealSearch as $d_Lmealorama_ScheduledMealSearch };
//# sourceMappingURL=mealorama.-Scheduled-Meal-Search.js.map
